import $ from 'jquery';
import * as config from '../../home24/core/config';

var clicked = false;
var $container = $('#home24-fixed-container');
var right = -$container.width() + 41;

$container.css('right', right);

$('.js-helparea').on('click', function () {
    if (!clicked) {
        clicked = true;
        window.location = $(this)
            .stop(true)
            .find('a')
            .prop('href');
    }
}).on('mouseenter', function () {
    $(this)
        .stop(true)
        .animate({ opacity: 1, right: -right }, config.getInt('general.appearSpeed'));
}).on('mouseleave', function () {
    $(this)
        .stop(true)
        .animate({ opacity: 1, right: '0' }, config.getInt('general.appearSpeed'));
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/helpareaBadge.js
 **/